export const FETCH_END = "getReported";
export const FETCH_START = "setLoading";
export const RESET_STATE = "resetModuleState";
